export default "__VITE_ASSET__BY5xL58A__"